export default __webpack_public_path__ + "static/media/icon-play.cfd7c553.svg";